import { render, staticRenderFns } from "./system-management.vue?vue&type=template&id=227a669b&scoped=true&"
import script from "./system-management.vue?vue&type=script&lang=ts&"
export * from "./system-management.vue?vue&type=script&lang=ts&"
import style0 from "./system-management.vue?vue&type=style&index=0&id=227a669b&prod&scoped=true&lang=css&"
import style1 from "./system-management.vue?vue&type=style&index=1&id=227a669b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a669b",
  null
  
)

export default component.exports